import { useEffect, useState } from 'react';
// import DropdownList from "react-widgets/DropdownList";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const Dropdown = (props) => {
  const { id, name, type, typeName, order, values, input: { onChange }, required } = props;

  const [options] = useState(values);
  const [value, setValue] = useState("");



  useEffect(() => {
    if (options && options.length > 0) {
      for (let option of options) {
        if (option.default) {
          setValue(option.id);
          // onChange(option);
          onChange({
            id,
            typeName,
            order,
            result: option
          });
          break;
        }
      }
    }
  }, []);

  // const changeHandler = (changeValue) => {
  //   if (changeValue && changeValue?.id != value) {
  //     setValue(changeValue.id);
  //     // return onChange(changeValue);
  //     return onChange({
  //       id,
  //       typeName,
  //       order,
  //       result: changeValue
  //     });
  //   }

  //   if (!required) {
  //     setValue(null);
  //     return onChange(null);
  //   }
  // }

  // return (
  //   <div>
  //     <DropdownList
  //       value={value}
  //       dataKey="id"
  //       textField="label"
  //       onChange={(value) => { changeHandler(value) }}
  //       onSelect={(value) => { changeHandler(value) }}
  //       data={options}
  //     />
  //   </div>
  // )

  const changeHandler = (event) => {
    const optionId = event?.target?.value;
    // if (optionId && optionId != value) {
    if (optionId !== null && optionId != value) {
      const option = options.find(el => el.id === optionId);

      if (option) {
        setValue(optionId);
        return onChange({
          id,
          typeName,
          order,
          result: option
        });
      }

      setValue(null);
      return onChange(null);
    }

    if (!required) {
      setValue(null);
      return onChange(null);
    }
  }

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth size='small'>
        <Select
          // id={id}
          value={value}
          onChange={changeHandler}

        >
          {options.map(option => (
            <MenuItem
              key={option.id}
              value={option.id}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default Dropdown;